/**
 * Helper para descargar ficheros (CSV, PDF, etc.) desde endpoints autenticados
 * por cookie. Usamos fetch + blob para asegurar que la sesión viaja en la
 * petición y para honrar el Content-Disposition del servidor cuando lo trae.
 */

import { notifyUnauthorized } from './api'

const API_BASE = import.meta.env.VITE_API_URL ?? '/api'

export async function downloadFile(path: string, fallbackName: string): Promise<void> {
  const res = await fetch(`${API_BASE}${path}`, { credentials: 'include' })
  if (!res.ok) {
    if (res.status === 401) notifyUnauthorized()
    throw new Error(`Descarga fallida (${res.status}): ${res.statusText}`)
  }
  // Intentamos extraer el filename de Content-Disposition.
  const disp = res.headers.get('Content-Disposition') ?? ''
  const match = /filename="?([^"]+)"?/i.exec(disp)
  const name = match?.[1] ?? fallbackName

  const blob = await res.blob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  // Liberamos el blob en el siguiente tick para que Safari termine la descarga.
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
